import { authUtils } from "@/scripts/authUtils.js";

/**
 * Mixin for handling authentication setup and cleanup on public pages
 * that redirect authenticated users to the dashboard.
 *
 * Usage: Add to component's mixins array
 * Example: mixins: [authSetupMixin]
 */
export const authSetupMixin = {
  data() {
    return {
      authUnsubscribe: null,
    };
  },
  mounted() {
    // Set up auth listener and store unsubscribe function
    this.authUnsubscribe = authUtils.setupAuth(
      this.$router,
      this.$route.query.redirect
    );
  },
  beforeUnmount() {
    // Clean up auth listener to prevent memory leaks
    if (this.authUnsubscribe) {
      this.authUnsubscribe();
    }
  },
};
